$(document).ready(function() {
            var initialImageSrc; // Variable to store the initial image src
            var initialIndex; // Variable to store the initial index
            var currentIndex; // Variable to store the current index

            // Get the initial active image and index on page load
            var $activeItem = $('.product__media-item.is-active');
            if ($activeItem.length > 0) {
                initialImageSrc = $activeItem.find('img').attr('src'); // Set initial src from active item
                initialIndex = $activeItem.index(); // Set initial index from active item
                currentIndex = initialIndex; // Set current index to initial index
                $('.ib-modal-prod-div img').attr('src', initialImageSrc); // Set modal image to active image src by default
            }

            // Function to update the modal image and indices based on the active item
            function updateModalImage() {
                var $activeItem = $('.product__media-item.is-active');
                if ($activeItem.length > 0) {
                    var newImageSrc = $activeItem.find('img').attr('src');
                    
                    var $modalInnerDiv = $('.ib-modal-prod-div-inner');
                    $modalInnerDiv.css('opacity', '0'); // Start fade-out

                    setTimeout(function() {
                        $('.ib-modal-prod-div img').attr('src', newImageSrc); // Change the image src
                        $modalInnerDiv.css('opacity', '1'); // Fade-in
                    }, 300); // Match this duration with the CSS transition duration
                }
            }

            // Create a MutationObserver instance to watch for changes in the DOM
            var observer = new MutationObserver(function(mutationsList) {
                mutationsList.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        // Check if the mutation target is a product media item
                        if ($(mutation.target).hasClass('product__media-item')) {
                            // Update the modal image and indices if the active class has changed
                            updateModalImage();
                        }
                    }
                });
            });

            // Configuration for the observer (observe changes to attributes)
            var observerConfig = {
                attributes: true,
                subtree: true,
                attributeFilter: ['class']
            };

            // Start observing the document for changes in .product__media-item elements
            $('.product__media-item').each(function() {
                observer.observe(this, observerConfig);
            });

            // Function to initialize the lightbox
            function initializeLightbox() {
                // Remove any previously attached event listeners to avoid duplication
                $('.ib-custom-prod-light-box .product__media img').off('click');
                $('.ib-prod-cross, .ib-modal-prod-div').off('click');
                $('.ib-prod-next-arrow').off('click');
                $('.ib-prod-prev-arrow').off('click');

                // Show the modal with the clicked image
                $('.ib-custom-prod-light-box .product__media img').on('click', function() {
                    initialImageSrc = $(this).attr('src'); // Store the initial src when opening the modal
                    initialIndex = $(this).closest('.product__media-item').index(); // Store the initial index
                    currentIndex = initialIndex; // Set current index to initial index

                    $('.ib-modal-prod-div img').attr('src', initialImageSrc);
                     $('.ib-modal-prod-div').hide().fadeIn(300);
                    $('.ib-modal-prod-div').css('display', 'flex');
                });

                $('.ib-prod-cross, .ib-modal-prod-div').on('click', function() {
                    $('.ib-modal-prod-div').css('display', 'none');

                    if (initialImageSrc) {
                        $('.ib-modal-prod-div img').attr('src', initialImageSrc);
                    }

                    currentIndex = initialIndex; // Reset current index to initial index
                });

                // Prevent closing modal when clicking inside the modal content
                $('.ib-modal-prod-div-inner').on('click', function(event) {
                    event.stopPropagation();
                });

                var $items = $('.product__media-item');
                var itemCount = $items.length;

                function updateNextImage() {
                    var $modalInnerDiv = $('.ib-modal-prod-div-inner');
                    $modalInnerDiv.css('opacity', '0'); // Start fade-out
                  currentIndex = (currentIndex + 1) % itemCount;
                        var nextImageSrc = $items.eq(currentIndex).find('img').attr('src');
                   $('.ib-modal-prod-div img').attr('src', nextImageSrc); // Change the image src
                    
                        
                        
                        $modalInnerDiv.css('opacity', '1'); // Fade-in
                    
                }

                function updatePrevImage() {
                    var $modalInnerDiv = $('.ib-modal-prod-div-inner');
                    $modalInnerDiv.css('opacity', '0'); // Start fade-out
                  currentIndex = (currentIndex - 1 + itemCount) % itemCount;
                        var prevImageSrc = $items.eq(currentIndex).find('img').attr('src');
$('.ib-modal-prod-div img').attr('src', prevImageSrc); // Change the image src
                        
                        $modalInnerDiv.css('opacity', '1'); // Fade-in
                 
                }
              function animateArrowOpacity($arrow) {
            // Animate the opacity of the arrow
            $arrow.css('opacity', '0'); // Start fade-out
            setTimeout(function() {
                $arrow.css('opacity', '1'); // Fade-in
            }, 500); // Match this duration with the CSS transition duration
        }

                $('.ib-prod-next-arrow').click(function() {
                  animateArrowOpacity($(this));  
                  updateNextImage();
                });

                $('.ib-prod-prev-arrow').click(function() {
                  animateArrowOpacity($(this));  
                  updatePrevImage();
                });
            }

            // Initialize the lightbox on page load
            initializeLightbox();

            // Initial setup: trigger the update once on page load
            updateModalImage();
  });


//extended warranty detail js
$(document).ready(function() {
  $(".extended-warranty-details").click(function() {
       $(".details-for-extend-warranty").slideToggle();
  });
});


// Product Options/Variants js
$(document).ready(function() {
  
  function updateSelectedVariant() {
    // Get the checked radio input
    const $checkedRadio = $('input[name="Select Length:"]:checked');
    
    // Get the corresponding label
    const $label = $checkedRadio.next('label');

    const selectedVariantText = $label.contents().filter(function() {
      return this.nodeType === 3;
    }).text().trim();

    $('.ib-prod-selected-variant').text(selectedVariantText);
    
  }

  updateSelectedVariant();

  $('input[name="Select Length:"]').change(function() {
    updateSelectedVariant();
  });
});


// need length and gram fancybox
$(document).ready(function() {
    $(".fancybox").fancybox();
});

$(document).ready(function() {
    // Select all buttons with the class 'scrollButton'
    $('.ib-sh-cartbuttonsticky').on('click', function() {
        if (window.innerWidth <= 479) {
            const targetElement = $('#ib-sh-prod-add-on');

            // Add margin to the target element
            const offset = 230;

            // Scroll to the target element without additional offset
            $('html, body').animate({
                scrollTop: (targetElement.offset().top - offset)
            }, 500);
        }
    });
});

// Function to add extended warranty product to cart
$(document).ready(function() {
    function addToCart(variantId, quantity) {
        console.log(`Adding variant ${variantId} with quantity ${quantity} to cart`);
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                id: variantId,
                quantity: quantity
            }),
            dataType: 'json',
            success: function(data) {
                console.log('Product added to cart:', data);
            },
            error: function(xhr, status, error) {
                console.error('Error adding product to cart:', error);
            }
        });
    }

    $('#40148620673112').on('change', function() {
        console.log('Checkbox 40148620673112 changed:', this.checked);
        if (this.checked) {
            addToCart(40148620673112, 1);
        }
    });

    $('#40146849497176').on('change', function() {
        console.log('Checkbox 40146849497176 changed:', this.checked);
        if (this.checked) {
            addToCart(40146849497176, 1);
        }
    });
});


// Product Add to cart btn

  window.addEventListener('DOMContentLoaded', function () {
       var section = document.querySelector('.for-sticky-cartbtn');
       var button = document.querySelector('.ib-sh-cartbuttonsticky');
       if (!section || !button) return;  // Exit if elements are not found

       var sectionBounds = section.getBoundingClientRect();
       // Initial check
       if (sectionBounds.bottom <= window.innerHeight + 150) {
         button.classList.remove('ibat-sticky-btn');
       } else {
         button.classList.add('ibat-sticky-btn');
       }

       window.addEventListener('scroll', function() {
         var sectionBounds = section.getBoundingClientRect();
         // Show the button when the section is about to disappear
         if (sectionBounds.bottom <= window.innerHeight + 150) {
           button.classList.remove('ibat-sticky-btn');
         } else {
           setTimeout(function(){
             var sectionBounds1 = section.getBoundingClientRect();
             if (!(sectionBounds1.bottom <= window.innerHeight + 150)) {
               button.classList.add('ibat-sticky-btn');
             }
           }, 100);
         }
       });
    });


  $(document).ready(function() {
    // Check if the device width is 479px or less
    var isMobile = window.matchMedia('only screen and (max-width: 479px)').matches;

    if (isMobile) {
      // Add the temporary class to the element with class 'ib-sh-page-padding'
      $('.ib-sh-page-padding').addClass('temp-fixed-cart-button');

      // Calculate the position of the 'Add to Cart' button
      var addToCartWrapperPos = $('.product-form__buttons').offset().top + 51;

      // Add scroll event listener
      $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        // Toggle classes based on scroll position
        if (scroll >= addToCartWrapperPos) {
          $('.product-form__buttons').addClass('with-padding');
          $('.ib-sh-page-padding').addClass('add-to-cart-fixed');
        } else {
          $('.product-form__buttons').removeClass('with-padding');
          $('.ib-sh-page-padding').removeClass('add-to-cart-fixed');
        }
      });

      // Add click event listener to the 'ib-sh-cartbuttonsticky' inside 'product-form__buttons'
      $('.product-form__buttons .ib-sh-cartbuttonsticky').on('click', function() {
        $('.fixed-product-info').addClass('item-added');
         $('.ib-sh-page-padding').addClass('temp-cart-button');
      });
    }
  });
